<template>
  <el-form
    ref="ruleFormRef"
    v-loading="loading"
    :model="ruleForm"
    :rules="rules"
    label-width="110px"
    class="demo-ruleForm"
    size="large"
    status-icon
  >
    <el-form-item label="IP地址" prop="ipAddress">
      <el-input
        style="width: 300px;"
        clearable
        v-model="ruleForm.ipAddress"
        placeholder="请输入IP地址"
      />
    </el-form-item>
    <el-form-item label="结束时间" prop="endTime">
      <el-date-picker
        v-model="ruleForm.endTime"
        type="datetime"
        placeholder="请选择结束时间"
        format="YYYY-MM-DD HH:mm:ss"
        value-format="YYYY-MM-DD HH:mm:ss"
        style="width: 300px;"
      />
    </el-form-item>
    <el-form-item label="理由" prop="reason">
      <el-input
        v-model="ruleForm.reason"
        :rows="4"
        type="textarea"
        placeholder="请输入理由"
        maxlength="200"
        show-word-limit
      />
    </el-form-item>
  </el-form>
  <div slot="footer" class="from_btn">
    <el-button @click="resetForm" size="large">取消</el-button>
    <el-button type="primary" v-if="!submitDisabled" size="large" @click="submitForm(ruleFormRef)"
      :disabled="submitDisabled">提交保存</el-button
    >
    <el-button type="primary" size="large" loading v-else>提交中</el-button>
  </div>
</template>

<script>
import {
  addBlackList,
  editBlackList,
  getBlackListDetail,
} from "network/blackList.js";
import { toRefs, reactive, ref, unref, onMounted } from "vue";
import { ElMessage, ElMessageBox } from "element-plus";

export default {
  name: "AddEditBlackList",
  components: {},
  emits: {
    "close-dialog": null,
    "update-list": null,
  },
  props: {
    editId: Number,
  },
  setup(props, { emit }) {
    const ruleFormRef = ref();
    const data = reactive({
      loading: false,
      ruleForm: {
        ipAddress: "",
        endTime: "",
        reason: "",
      },
      rules: {
        ipAddress: [
          { required: true, message: "请输入IP地址" },
          {
            pattern: /^((25[0-5]|2[0-4]\d|[01]?\d\d?)\.){3}(25[0-5]|2[0-4]\d|[01]?\d\d?)$/,
            message: "请输入正确的IP地址格式"
          },
        ],
        endTime: [
          {
            required: true,
            message: "请选择结束时间",
          },
          {
            validator: (rule, value, callback) => {
              if (value && new Date(value) <= new Date()) {
                callback(new Error('结束时间必须大于当前时间'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          },
        ],
      },
      submitDisabled: false,
    });

    onMounted(() => {
      //编辑-获取详情
      if (props.editId > 0) {
        data.loading = true;
        getBlackListDetail(props.editId).then((result) => {
          if (result && result.code == 1) {
            data.loading = false;
            data.ruleForm = result.result;
          } else {
            data.loading = false;
              ElMessageBox.alert(result.message || result.msg || "获取数据失败");
          }
        }).catch((err) => {
          data.loading = false;
          console.log(err);
        });
      }
    });

    // 提交
    const submitForm = async () => {
      const form = unref(ruleFormRef);
      if (!form) return;
      try {
        const valid = await form.validate();
        if (!valid) {
          return false;
        } else {
          data.submitDisabled = true;
          updataAdd().then(() => {
            data.submitDisabled = false;
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    async function updataAdd() {
      data.loading = true;
      let result;
      if (props.editId > 0) {
        data.ruleForm.id = props.editId;
        result = await editBlackList(data.ruleForm);
      } else {
        result = await addBlackList(data.ruleForm);
      }
      if (result && result.code == 1) {
        data.loading = false;
        ElMessage.success(result.message || (props.editId > 0 ? "编辑成功" : "添加成功"));
        emit("close-dialog");
        emit("update-list");
      } else {
        data.loading = false;
        ElMessageBox.alert(result.message || result.msg || (props.editId > 0 ? "编辑失败" : "添加失败"));
      }
    }

    // 取消操作  关闭弹窗
    const resetForm = () => {
      emit("close-dialog");
      ruleFormRef.value.resetFields();
    };

    return {
      ...toRefs(data),
      submitForm,
      ruleFormRef,
      resetForm,
    };
  },
};
</script>

<style scoped>
:deep(.el-input__inner) {
  outline: none;
  line-height: 1px;
}

.demo-ruleForm {
  width: 100%;
  height: 350px;
}
</style>